import { brands as Brands } from '@/types/thermostatBrands'

function useViewModel() {
  return {
    brands: Brands,
  }
}

export default useViewModel
